

export const FETCH_RATEADMIN_RATEPLAN_LIST = {
    START: 'FETCH_RATEADMIN_RATEPLAN_LIST_START',
    SUCCESS: 'FETCH_RATEADMIN_RATEPLAN_LIST_SUCCESS',
    ERROR: 'FETCH_RATEADMIN_RATEPLAN_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_RATEADMIN_RATEPLAN_INIT="FETCH_RATEADMIN_RATEPLAN_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_RATEADMIN_RATEPLAN_SCREEN =
'INIT_CREATE_RATEADMIN_RATEPLAN_SCREEN';

export const CREATE_RATEADMIN_RATEPLAN = {
START: 'CREATE_RATEADMIN_RATEPLAN_START',
SUCCESS: 'CREATE_RATEADMIN_RATEPLAN_SUCCESS',
ERROR: 'CREATE_RATEADMIN_RATEPLAN_ERROR',
};

export const EDIT_RATEADMIN_RATEPLAN = {
START: 'EDIT_RATEADMIN_RATEPLAN_START',
SUCCESS: 'EDIT_RATEADMIN_RATEPLAN_SUCCESS',
ERROR: 'EDIT_RATEADMIN_RATEPLAN_ERROR',
};

export const FETCH_RATEADMIN_RATEPLAN_DETAIL = {
  START: 'FETCH_RATEADMIN_RATEPLAN_DETAIL_START',
  SUCCESS: 'FETCH_RATEADMIN_RATEPLAN_DETAIL_SUCCESS',
  ERROR: 'FETCH_RATEADMIN_RATEPLAN_DETAIL_ERROR',
};
export const EXPORT_RATEADMIN_RATEPLAN = {
  START: 'EXPORT_RATEADMIN_RATEPLAN_START',
  SUCCESS: 'EXPORT_RATEADMIN_RATEPLAN_SUCCESS',
  ERROR: 'EXPORT_RATEADMIN_RATEPLAN_ERROR',
};
export const RATEADMIN_RATEPLANDD = {
  START: 'RATEADMIN_RATEPLANDD_START',
  SUCCESS: 'RATEADMIN_RATEPLANDD_SUCCESS',
  ERROR: 'RATEADMIN_RATEPLANDD_ERROR',
};

export const RATEADMIN_RATEPLAN_SAVE_TABLE_STATE = 'RATEADMIN_RATEPLAN_SAVE_TABLE_STATE';